// Services/CategoryService.js
import { Variables } from "../../../Variations/Variations";
import Cookies from "js-cookie";
import { withLoader } from "../../../Services/ApiClient";

const headers = () => ({
  Accept: "application/json",
  "Content-Type": "application/json",
  Authorization: `Bearer ${Cookies.get("UserToken")}`,
});

const handle = async (res) => {
  if (!res.ok) {
    const text = await res.text();
    throw text || "Request failed";
  }

  if (res.status === 204) return null;

  const text = await res.text();
  return text ? JSON.parse(text) : null;
};

export const CategoryService = {

  /* ================= CATEGORY ================= */

  getPaged: (page, pageSize, search = "") =>
    withLoader(
      fetch(
        `${Variables.API_URL}Category/GetCategoriesPaged?page=${page}&pageSize=${pageSize}&search=${encodeURIComponent(search)}`,
        { headers: headers() }
      ).then(handle)
    ),

  getById: (id) =>
    withLoader(
      fetch(`${Variables.API_URL}Category/GetCategory/${id}`, {
        headers: headers(),
      }).then(handle)
    ),

  create: (payload) =>
    withLoader(
      fetch(`${Variables.API_URL}Category/AddCategory`, {
        method: "POST",
        headers: headers(),
        body: JSON.stringify(payload),
      }).then(handle)
    ),

  update: (id, payload) =>
    withLoader(
      fetch(`${Variables.API_URL}Category/UpdateCategory/${id}`, {
        method: "PUT",
        headers: headers(),
        body: JSON.stringify(payload),
      }).then(handle)
    ),

  togglePublish: (id) =>
    withLoader(
      fetch(`${Variables.API_URL}Category/TooglePublishCategory/${id}`, {
        method: "PUT",
        headers: headers(),
      }).then(handle)
    ),

  getParents: () =>
    withLoader(
      fetch(`${Variables.API_URL}Category/GetCategoriesParent`, {
        headers: headers(),
      }).then(handle)
    ),

  /* ================= MEDIA ================= */

  getMedia: () =>
    withLoader(
      fetch(`${Variables.API_URL}UploadMedia/GetMedia`, {
        headers: headers(),
      }).then(handle)
    ),

  uploadMedia: (file) => {
    const formData = new FormData();
    formData.append("Image", file);

    return withLoader(
      fetch(`${Variables.API_URL}UploadMedia/UploadImageToServer`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${Cookies.get("UserToken")}`,
        },
        body: formData,
      }).then(handle)
    );
  },
};
